import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';
import { LocalStorageService } from './local-storage.service';

@Injectable({
  providedIn: 'root',
})
export class AuthService {
  private httpClient = inject(HttpClient);
  private localStorage = inject(LocalStorageService);

  //Check if user is logged in
  isLoggedIn(): boolean {
    return !!this.localStorage.getFromStorage('token');
  }

  getUserFromJwt(): any {
    const token = this.localStorage.getFromStorage('token');
    if (!token) {
      return null;
    }

    const payload = atob(token.split('.')[1]);
    return JSON.parse(payload);
  }

  loginConsignee(loginDto: any): Observable<any> {
    return this.httpClient.post<any>(
      `${environment.apiUrl}authentication/consignee`,
      loginDto
    );
  }
  verifyConsigneePassword(
    consigneeId: string,
    password: string
  ): Observable<any> {
    return this.httpClient.get<any>(
      `${environment.apiUrl}Consignee/verify/${consigneeId}`,
      {
        params: { password },
      }
    );
  }

  updateConsigneePassword(id: string, newPassword: string): Observable<any> {
    return this.httpClient.put<any>(
      `${environment.apiUrl}authentication/consignee/update-password`,
      {
        id: id,
        newPassword: newPassword,
      }
    );
  }

  requestConsigneePasswordReset(email: string): Observable<any> {
    return this.httpClient.get<any>(
      `${environment.apiUrl}authentication/consignee/request-reset-password?email=${email}`
    );
  }
}
